<template>
  <div>
    <div
      class="br-amount form-input --data-format-right"
      data-format="%"
      v-bind:class="{ '--has-error': showError == true }"
    >
      <label class="form-label" data-tool-tip="true">
        <info-icon></info-icon>
      </label>
      <input
        name="interest-rate"
        data-ri-filtervalue="[name='interest-rate']"
        v-model="value"
        v-bind:data-ri-filtername="filterName"
        v-on:focus="selectAll"
        v-on:blur="validateAmount($event.target.value)"
        v-on:keyup.enter="validateAmount($event.target.value)"
        class="gearbox-input"
      />
    </div>
    <span
      class="error-message interest-input__error"
      v-if="showError == true"
      >{{ error }}</span
    >
  </div>
</template>
<style lang="scss">
@import '../../../../../sass/brcom/settings/_settings.theme-colors.scss';
.interest-input__error {
  color: $theme-red-dark;
  font-family: 'Calibre-Regular', Arial, sans-serif;
}
</style>
<script>
import utils from './../../../../bankrate-utilities/index'
import eventHub from '../../../bankrate-events'
import infoIcon from '../../../legacy-components/rt-info.vue'

export default {
  components: {
    'info-icon': infoIcon
  },

  props: {
    value: {
      type: Number
    },
    defaultValue: {
      type: Number
    },
    title: {
      type: String
    },
    error: {
      type: String
    },
    minValue: {
      type: Number
    },
    maxValue: {
      type: Number
    },
    copy: {
      default: function() {
        return []
      }
    }
  },

  data: function() {
    return {
      lastValue: '',
      showError: ''
    }
  },

  computed: {
    filterName: function() {
      return utils.dataCollectorFormat(this.title.toLowerCase())
    }
  },

  mounted: function() {
    eventHub.$emit('calculator::setInterestRate', this.defaultValue)
    this.lastValue = this.defaultValue.toString()
  },

  methods: {
    cleanValue: function(value) {
      return value.replace(/[^0-9\\.]/g, '')
    },

    updateAmount: function(value) {
      let cleanedValue = this.cleanValue(value)

      // NO errors and different value
      if (!this.hasDisplayError(value) && this.lastValue !== cleanedValue) {
        this.value = cleanedValue
        eventHub.$emit('calculator::setInterestRate', this.value)
      }

      this.lastValue = cleanedValue
    },

    validateAmount: function(value) {
      if (
        this.lastValue !== this.cleanValue(value) &&
        !this.hasDisplayError(value)
      ) {
        this.updateAmount(value)
      }
    },

    hasDisplayError: function(value) {
      value = parseFloat(value)
      if (
        value > parseFloat(this.minValue) &&
        value < parseFloat(this.maxValue)
      ) {
        this.showError = false
        return false
      } else {
        this.showError = true
        return true
      }
    },

    selectAll: function(event) {
      // Workaround for Safari bug
      // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
      setTimeout(function() {
        event.target.select()
      }, 0)
    }
  }
}
</script>
